import { TPipeline } from "@/frontend/pages/DashboardPage/model/types/types";
import $api from "@/frontend/shared/api/axios";

export async function postCreatePipeline({ name }: { name: string }) {
  const res = await $api.post<{ data: TPipeline }>("/pipelines", {
    name
  });

  return res.data.data;
}
